// extracted by mini-css-extract-plugin
module.exports = {"brand_color_main":"var(--brand_color_main)"};